import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {ConfigService} from "../../services/configservice/config.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private configService: ConfigService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.configService.getJWT() != null) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.configService.getJWT()
        }
      });
    }
    return next.handle(request);
  }
}
